import React, { useState, useEffect } from "react";
import PopupExample from "./PopupExample";
import { useParams } from "react-router-dom";
import config from "../../config/Config";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

export default function Comment() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleReplies, setVisibleReplies] = useState({});
  //const { id } = useParams();
  const storedPostId = localStorage.getItem("post_id");
  // Fetch comments from the API
  function fetchComments() {
    fetch(`${config.API_BLOG}comments`)
      .then((response) => response.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchComments();
  }, []);

  // Filter comments for the current post
  const filteredData = data.filter(
    (item) => item.comment_status === 1 && item.comment_post_id == storedPostId,
  );

  // Handle showing replies for a comment
  const handleShowReplies = (commentId) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };

  // Get replies for a specific comment
  const getReplies = (commentId) =>
    data.filter(
      (item) => item.comment_status === 1 && item.comment_parent == commentId,
    );

  // Recursive component to render comments and their replies
  const renderComments = (comments) =>
    comments.map((comment) => (
      <div
        key={comment.comment_id}
        className="fs-6"
        style={{ marginLeft: "20px" }}
      >
        <div style={{ fontSize: "16px" }} className="heading_font">
          @{comment.comment_author_name}
        </div>
        <span style={{ fontSize: "14px", fontFamily: "sofia" }}>
          {comment.comment_content}
        </span>
        <PopupExample m={comment.comment_id} />
        {getReplies(comment.comment_id).length > 0 && (
          <p
            onClick={() => handleShowReplies(comment.comment_id)}
            className="replies_button"
          >
            {visibleReplies[comment.comment_id] ? (
              <span style={{ fontSize: "15px", fontFamily: "sofia" }}>
                <BsChevronUp className="me-1" />
                {getReplies(comment.comment_id).length} replies
              </span>
            ) : (
              <span style={{ fontSize: "15px", fontFamily: "sofia" }}>
                <BsChevronDown className="me-1" />
                {getReplies(comment.comment_id).length} replies
              </span>
            )}
          </p>
        )}
        {visibleReplies[comment.comment_id] && (
          <div>{renderComments(getReplies(comment.comment_id))}</div>
        )}
      </div>
    ));

  return (
    <div className="container-fluid page-shell py-4">
      <div data-aos="fade-up">
        <span className="fs-2 heading_font me-2">Comments:-</span>
        <div className="mt-3">
          {loading ? (
            <p>Loading...</p>
          ) : filteredData.length === 0 ? (
            <p>No comments available.</p>
          ) : (
            <div>
              {renderComments(
                filteredData.filter(
                  (comment) => comment.comment_parent === null,
                ),
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
